import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import Cookies from "universal-cookie";
import "./css/index.css";
import configureStore from "./store";
import { refreshAuthToken } from "actions/session";
import App from "./containers/App";
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from "./registerServiceWorker";

// Check for BaseAPI Env Variable
if (process.env.REACT_APP_BaseAPI !== undefined) {
  window.sessionStorage.setItem("BaseAPI", process.env.REACT_APP_BaseAPI);
} else {
  window.sessionStorage.setItem(
    "BaseAPI",
    "https://rls-uatapi.certihomes.com/api/rebny/"
  );
}
window.sessionStorage.setItem(
  "RootAPI",
  window.sessionStorage.getItem("BaseAPI") + ""
);

const initialState = {};
const store = configureStore(initialState);

const cookies = new Cookies();
const authToken = cookies.get("authDetails");
if (authToken) {
  store.dispatch(refreshAuthToken());
}

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

//registerServiceWorker();
// Because Service Workers were added before we have to disable them
unregister();
